import { ADD_NEW_ACCOUNT, getScopedItem, STORAGE_KEYS } from "../components/common/Helper";
import APIConstants from "./APIConstants";
import APIService, { setAuthToken } from "./APIService";
import DebugService from "./DebugService";

/**
 * @description Menu Api Service
 */
const MenuApiService = {

  get: async (selectedAccount, selectedPlatform, menuEnum = '') => {
    try {
      let url = APIConstants.ENDPOINT_MENU
      url += `?`

      if (getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)) {
        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (selectedAccount && selectedAccount !== ADD_NEW_ACCOUNT) {
          url += `userAccountId=${selectedAccount}&`
        }

        if (selectedPlatform) {
          url += `platformEnum=${selectedPlatform}&`
        }

        if (parseToJson['userId']) {
          url += `userId=${parseToJson['userId']}`
        }
      }

      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      return await APIService.get(url)
        .then(response => {
          DebugService.log('Menu Api Service: Response', response)
          const data = response['data']

          for (let x = 0; x < data.length; x++) {
            if (data[x]['submenu'].length > 0) {
              for (let i = 0; i < data[x]['submenu'].length; i++) {
                data[x]['submenu'][i]['id'] = `s${data[x]['submenu'][i]['id']}`
              }
            }
          }

          return data
        })
    } catch (err) {
      DebugService.error('Menu Service: Error Caught while fetching menu', err, selectedAccount, selectedPlatform)
    }
  },

  getSubmenu: async (selectedAccount, selectedPlatform, menuEnum = '') => {
    try {
      let url = APIConstants.ENDPOINT_SUBMENU_LIST
      url += `?`

      if (selectedPlatform) {
        url += `platformEnum=${selectedPlatform}&`
      }

      if (menuEnum) {
        url += `eNum=${menuEnum}`
      }

      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      return await APIService.get(url)
        // .then(response => {
        //   DebugService.log('Menu Api Service: Response', response)
        //   const data = response['data']

        //   for (let x = 0; x < data.length; x++) {
        //     if (data[x]['submenu'].length > 0) {
        //       for (let i = 0; i < data[x]['submenu'].length; i++) {
        //         data[x]['submenu'][i]['id'] = `s${data[x]['submenu'][i]['id']}`
        //       }
        //     }
        //   }

        //   return data
        // })
    } catch (err) {
      DebugService.error('Menu Service: Error Caught while fetching menu', err, selectedAccount, selectedPlatform)
    }
  },
};

export default MenuApiService;
